export default "__VITE_ASSET__jSR6wTPF__"